// src/console-mute.js
// Runs immediately on import and mutes console output.
// WARNING: This mutes ALL console output. Use temporarily during debugging only.

(function globalConsoleMute() {
    const FORCE_MUTE = true; // set false to unmute
  
    if (!FORCE_MUTE) return;
  
    // preserve original console
    window.__origConsole = { ...(window.console || {}) };
  
    // allowlist (keep empty to swallow everything)
    const ALLOW_PATTERNS = [];
  
    function shouldAllow(args) {
      if (!args || !args.length) return false;
      try {
        const text = args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');
        return ALLOW_PATTERNS.some(p => (p instanceof RegExp ? p.test(text) : text.includes(p)));
      } catch (e) {
        return false;
      }
    }
  
    ['log','info','warn','error','debug','trace'].forEach(fn => {
      console[fn] = function(...args) {
        try {
          if (shouldAllow(args)) {
            return window.__origConsole[fn]?.apply(window.__origConsole, args);
          }
          // swallowed
        } catch (e) {}
      };
    });
  
    // stop default browser prints for uncaught errors/unhandled rejections (prevents duplicate prints)
    window.addEventListener('error', e => { try { e.preventDefault(); } catch(_){} }, { capture: true });
    window.addEventListener('unhandledrejection', e => { try { e.preventDefault(); } catch(_){} }, { capture: true });
  })();
  